export class Dmenu {
    constructor() {
        this.body = {}
        this.html = {}
        this.windowWidth = 0;

        // SP
        this.menuHamburger = {}
        this.spSubMenuScrollContainer = {}
        this.spMenu = {}
        this.spSubMenuOpenBtn = {}

        // PC
        this.pcMainMenu = {}
        this.pcSubMenuAcc = {}
    }


    envCheck() {

        //環境チェック

        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];
        let wwNow = (window.innerWidth || document.documentElement.clientWidth || 0);

        //console.log('dmenu envCheck: now=' + wwNow + ', then=' + this.windowWidth + ', touch=' + window.ontouchstart);

        //ウインドウ幅が変わっていたらチェック
        if (this.windowWidth !== wwNow) {
            //console.log('dmenu envCheck: change menu-mode');

            let menuModeClick = true;
            this.body.classList.remove('menu-mode-pc');
            this.body.classList.remove('menu-mode-sp');

            if (window.ontouchstart === null) {
                //タッチ端末である
                menuModeClick = false;
                //this.body.classList.add('is-touch-device');

                if (wwNow >= 600) {
                    //タブレットサイズはフッターメニューを消す
                    this.body.classList.add('menu-mode-tablet');
                }

            } else {
                //タッチ端末でない
                if (wwNow >= 1000) { //cssと同期
                    menuModeClick = true;
                } else {
                    menuModeClick = false; //ウインドウ幅が小さければtouchメニュー
                }
            }

            if (menuModeClick) {
                this.body.classList.add('menu-mode-pc');
            } else {
                this.body.classList.add('menu-mode-sp');
            }
        }
        this.windowWidth = wwNow;
    }

    menuClicked() {
        // サブメニューを閉じる機能 (ドロワーメニュー内のリンクやXボタンなどを押した場合に)
        //this.checked = false;
        this.body.classList.remove('is-menu-open');
        //this.menuHamburger.checked = false;
    }

    init() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];


        // SP MENU
        // -----------
        this.menuHamburger = document.getElementById('drawer-menu-trigger');

        if (document.getElementById('drawer-menu-trigger')) {
            // チェックボックス変更時
            this.menuHamburger.addEventListener('click', () => {
                //console.log('menu trigger changed: ' + this.checked);

                if (this.body.classList.contains('is-menu-open')) {
                    //ドロワーメニュー閉じる
                    this.body.classList.remove('is-menu-open');
                    this.body.classList.add('is-menu-closing');

                    //ドロワーメニュー閉じた後
                    //var _this = this;
                    window.setTimeout(() => {
                        this.body.classList.remove('is-menu-closing');
                        if (!this.body.classList.contains('is-menu-open')) {
                            this.body.classList.add('is-menu-closed');
                        }
                    }, 400);
                } else {
                    //ドロワーメニュー開く
                    this.body.classList.remove('is-menu-closed');
                    this.body.classList.add('is-menu-open');
                }
            });

            // サブメニュー アコーディオン
            this.spMenu = document.getElementById('drawer-menu-container');
            this.spSubMenuOpenBtn = document.querySelectorAll('.header-sp .menu-has-child__button');

            [].forEach.call(this.spSubMenuOpenBtn, (elem) => {
                //console.log(elem);

                elem.parentElement.parentElement.querySelector('.menu-child__container').style.height = '0px';
                elem.addEventListener('click', () => {
                    let menuMain = elem.parentElement.parentElement;
                    let subMenuContainer = menuMain.querySelector('.menu-child__container');
                    if (menuMain.classList.contains('is-menu-open')) {
                        menuMain.classList.remove('is-menu-open');
                        this.changeHeightSp(elem, false);
                    } else {
                        menuMain.classList.add('is-menu-open');
                        this.changeHeightSp(elem, true);
                    }
                });
            });

        }



        // PC MENU
        // -----------
        // 子メニューを持つメインメニュー
        if (document.querySelectorAll('.header-pc__menu ul.menu li.menu__item')[0]) {
            this.pcMainMenu = document.querySelectorAll('.header-pc__menu ul.menu li.menu__item');

            [].forEach.call(this.pcMainMenu, (elem) => {
                if (elem.querySelectorAll('.menu-child__container')[0]) {
                    //console.log(elem);
                    let mySubMenu = elem.querySelector('.menu-child__container');
                    mySubMenu.style.height = '0px';

                    elem.addEventListener('mouseenter', (e) => {
                        e.currentTarget.classList.add('is-menu-open');
                        this.changeHeightPc(mySubMenu, true);
                    });
                    elem.addEventListener('mouseleave', (e) => {
                        e.currentTarget.classList.remove('is-menu-open');
                        this.changeHeightPc(mySubMenu, false);
                    });
                }

            });
        }

        // 孫メニューをもつ子メニュー
        this.pcSubMenu = document.querySelectorAll('.header-pc__menu ul.menu li.menu__item ul.menu-child li.menu-child__item');
        [].forEach.call(this.pcSubMenu, (elem) => {
            if (elem.querySelectorAll('.menu-child__container')[0]) {

                let mySubMenu = elem.querySelector('.menu-child__container');
                mySubMenu.style.height = '0px';

                var posY = elem.getBoundingClientRect().top;
                var parentPosY = elem.parentElement.parentElement.getBoundingClientRect().top;
                //console.log(posY - parentPosY);
                mySubMenu.style.top = (posY - parentPosY - 10) + 'px';


                elem.addEventListener('mouseenter', (e) => {
                    elem.classList.add('is-grandchild-menu-open');
                    e.currentTarget.classList.add('is-menu-open');
                    this.changeHeightPc(mySubMenu, true);
                });
                elem.addEventListener('mouseleave', (e) => {
                    elem.classList.remove('is-grandchild-menu-open');
                    e.currentTarget.classList.remove('is-menu-open');
                    this.changeHeightPc(mySubMenu, false);
                });
            }
        });

    }

    removeListener() {
        // addEventListener が重複して登録される場合 https://qiita.com/yuki153/items/c909c54204eaab6ca1b2
    }

    changeHeightPc(elem, openFlg) {
        let openHeight = 0;
        if (openFlg) {

            //elem.style.height = elem.querySelector('.menu-child').clientHeight + 'px';

            var openHeight1 = 0; //孫メニュー
            var openHeight2 = 0; //子メニュー

            //孫メニューの高さ(最大)の計算
            if (elem.querySelectorAll('ul.menu-child li.menu-child__item .menu-child__container ul.menu-child')[0]) {
                var targetElems = elem.querySelectorAll('ul.menu-child li.menu-child__item .menu-child__container ul.menu-child')
                for (let i = 0; i < targetElems.length; i++) {
                    //console.log(targetElems[i].clientHeight);
                    openHeight1 = Math.max(openHeight1, targetElems[i].clientHeight);
                }
            }

            //子メニューの高さの計算
            openHeight2 = elem.querySelector('.menu-child').clientHeight;

            if (elem.parentElement.classList.contains('js-menu-has-grandchild')) {
                //孫メニュー
                openHeight = openHeight2;
            } else {
                //子メニューの高さには、孫メニュー分足す/overflow対策
                openHeight = openHeight1 + openHeight2;
            }
        }
        elem.style.height = openHeight + 'px';
    }


    changeHeightSp(elem, openFlg) {
        //SPメニューの場合は、子メニューの高さに開いている孫メニューの高さを足す必要がある
        //console.log(elem);

        var isGrandChild = false;

        //子メニュー・自分自身
        var openHeight = 0; //押されたボタンのメニューの高さ
        var openMenuElem;
        var targetLi;

        //孫メニュー・自分自身
        var openHeight2 = 0;
        var openMenuElem2;
        var targetLi2;

        var openMenuElemGrand; //開いている孫メニュー

        //SPメニューの場合はelemはボタン、子メニューか孫メニューか判定
        if (elem.classList.contains('js-btn-has-grandchild')) {
            //孫メニューのボタン
            isGrandChild = true;
        }

        // 場合分け
        if (isGrandChild) {
            // 孫メニューの場合
            // --------
            targetLi2 = elem.parentElement.parentElement;
            openMenuElem2 = targetLi2.querySelectorAll('.menu-child__container')[0];

            //孫メニューの属する子メニュー
            targetLi = elem.parentElement.parentElement.parentElement.parentElement.parentElement;
            openMenuElem = targetLi.querySelectorAll('.menu-child__container')[0];

            if (openFlg) {
                openHeight2 = targetLi2.querySelectorAll('.menu-child__container .menu-child')[0].clientHeight;
            }

            openMenuElem2.style.height = openHeight2 + 'px'; //孫
            openMenuElem.style.height = 'auto';

        } else {
            // 子メニューの場合
            // --------
            targetLi = elem.parentElement.parentElement;
            openMenuElem = targetLi.querySelectorAll('.menu-child__container')[0];

            if (openFlg) {
                openHeight = targetLi.querySelectorAll('.menu-child__container .menu-child')[0].clientHeight;
                openMenuElem.style.height = openHeight + 'px'; //子
            } else {
                openHeight = targetLi.querySelectorAll('.menu-child__container .menu-child')[0].clientHeight;
                openMenuElem.style.height = openHeight + 'px'; //子
                setTimeout(() => {
                    openMenuElem.style.height = '0px';
                }, 10);
            }
        }
    }

    resizeDrawerAcc() {
        //リサイズ対応
    }



}